import React, { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { genreOptionsAssessment } from "../../../constants";
import classes from "../criteriaSubmission.module.css";
import checkboxClasses from "./questionTypes/questionTypes.module.css";
import { selectFormData, setFormData } from "../../../slices/form";
import OptionsDropDown from '../../UI/options_drop_down/options_drop_down';

const Genre = ({ isLoading, handleInputChange }) => {
  const formData = useSelector(selectFormData);
  const dispatch = useDispatch();

  const { genre, show_text } = formData || "";

    // Reset primary_source and primary_source_author when genre changes and does not include `Nonfiction text`
    useEffect(() => {
      if (!genre?.includes(`Nonfiction text`) && (formData.primary_source || formData.primary_source_author)) {
        dispatch(
          setFormData({
            primary_source: false,
            primary_source_author: "",
          })
        );
      }
    }, [genre, formData, dispatch]);

  const genreOptions = {
    "Closed book": genreOptionsAssessment,
    "Open book": genreOptionsAssessment.slice(0, 3),
    "None selected": [{name: "None selected", value: ''}],
  };

  return (
    <>
      <div className={classes["input-container"]}>
  <label className={classes.formLabel} htmlFor="genre">Describe the content you are uploading:</label>
        <OptionsDropDown
          name="genre"
          onChangeHandler={handleInputChange}
          options={genreOptions[show_text] || [{name: "None selected", value: ''}]}
          isDisabled={isLoading}
          isRequired={true}
          value={genre}
        />
      </div>
      {genre?.includes(`Nonfiction text`) ? (
        <>
          <div
            style={{
              marginTop: "10px",
              alignItems: "left",
              alignContent: "left",
            }}
            className={checkboxClasses.individualCheckbox}
          >
            <label className={checkboxClasses.container}>
              <input
                name={`optionsCount`}
                type="checkbox"
                checked={!!formData.primary_source} // Convert to boolean
                onChange={(e) => {
                  const isChecked = e.target.checked;
                  dispatch(
                    setFormData({
                      primary_source: isChecked,
                      // Clear the primary_source_author if the checkbox is unchecked
                      ...(isChecked ? {} : { primary_source_author: "" }),
                    })
                  );
                }}
              />
              <span className={checkboxClasses.checkmark}></span>
            </label>
            <span>Text is a primary source</span>
          </div>
          <div style={{
             display: "flex", // Align items to the left
             alignItems: "center", // Center items vertically in the container
             marginTop: "5px", // Reduce space between checkbox and input field
             marginLeft: "-20px"
            }}
          >
            {/* Conditionally render the input for author's name */}
            {formData.primary_source && (
              <>
              <label htmlFor="primary_source_author" style={{ fontWeight: "normal", marginRight: "10px" }}>Author's Name</label>
              <input
                id="primary_source_author"
                name="primary_source_author"
                type="text"
                value={formData.primary_source_author || ""}
                onChange={(e) =>
                  dispatch(
                    setFormData({
                      primary_source_author: e.target.value,
                    })
                  )
                }
                style={{ width: "300px"}}
              />
              </>
          )}
          </div>
        </>
      ) : null}
    </>
  );
};

export default Genre;
